import {
  HttpClient
} from '@angular/common/http';
import {
  Component,
  OnInit
} from '@angular/core';
import {
  ActivatedRoute
} from '@angular/router';
import {
  NgbModal
} from '@ng-bootstrap/ng-bootstrap';
import Enumerable
  from 'linq';
import {
  forkJoin
} from 'rxjs';
import {
  ConferenceCertificateViewModel,
  ConferenceViewModel,
  CourseEventViewModel,
  OrganizationCertificationViewModel,
  StringViewModel
} from 'src/app/_models/generatedModels';
import {
  CEUService,
  CourseService,
  EventService,
  OrganizationService
} from 'src/app/_services/generatedServices';
import {
  SettingsProvider
} from 'src/app/_services/settingsProvider.service';
import {
  AddUserCertificationModalComponent
} from '../certifications/add-user-certification-modal.component';

@Component({
  selector: 'bxl-teaching-certificates',
  templateUrl: 'teaching-certificates.component.html',
})
export class TeachingCertificatesComponent implements OnInit {
  initialized = false;
  courseEventId: number;
  courseEvent: CourseEventViewModel;
  certifications: OrganizationCertificationViewModel[];
  currentCertificate: ConferenceCertificateViewModel;
  selectedBody: OrganizationCertificationViewModel;
  totalCEs = 0;
  totalCEsSubType1 = 0;
  totalCEsSubType2 = 0;
  submitComplete: Promise<{}> | undefined;
  loading: boolean;

  constructor(private route: ActivatedRoute, private courseEventService: EventService, private modalService: NgbModal, public settings: SettingsProvider, public http: HttpClient, private organizationService: OrganizationService, private ceuService: CEUService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.courseEventId = +params['courseEventId'];

      //forkJoin()

      this.courseEventService.getSpecificCourseEvent(this.courseEventId.toString()).subscribe((courseEvent) => {
        this.ceuService.getTeachingCertificationsWithGeneratedCertificatesForForCourseEvent(this.courseEventId).subscribe((certs) => {
          this.courseEvent = courseEvent;
          this.certifications = certs;
          this.initialized = true;
        });
      });
    });
  }


  addCertification() {
    const modalRef = this.modalService.open(AddUserCertificationModalComponent, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'flyout',
      backdropClass: 'flyout',
      backdrop: 'static'
    });
    modalRef.componentInstance.lockTocertificationBodyId = this.currentCertificate.certification.certificationBodyId;
    modalRef.result.then(
      (result) => {
        this.currentCertificate = null;
      },
      (reason) => {
        //this.getData();
      }
    );
  }

  selectionChanged(event) {
    this.currentCertificate = null;
    console.log(this.selectedBody.userHasGenerated);

    if (this.selectedBody.userHasGenerated) {
      this.generateCertificate(false);
    }
  }

  generateCertificate(regenerate: boolean) {
    this.loading = true;

    this.ceuService.generateTeachingCertificateForCourseEvent(this.courseEvent.id, this.selectedBody.certificationBodyId, regenerate).subscribe((cert) => {
      this.currentCertificate = cert;
      this.selectedBody.userHasGenerated = true;
      this.currentCertificate.events.forEach((event) => {
        event.ceus = Enumerable.from(event.ceus)
          .where((x) => x.certificationBodyId == this.selectedBody.certificationBodyId)
          .toArray();
      });

      this.totalCEs = Enumerable.from(this.currentCertificate.events)
        .selectMany((x) => x.ceus)
        .sum((x) => x.ceuCount);
      this.totalCEsSubType1 = Enumerable.from(this.currentCertificate.events)
        .selectMany((x) => x.ceus)
        .sum((x) => x.subType1CEUCount);
      this.totalCEsSubType2 = Enumerable.from(this.currentCertificate.events)
        .selectMany((x) => x.ceus)
        .sum((x) => x.subType2CEUCount);

      this.loading = false;
    });
  }
}
